import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { startOfTomorrow } from "date-fns";

function useUTMTracker() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const utmParams = {
      utm_source: params.get("utm_source")?.trim() || "",
      utm_medium: params.get("utm_medium")?.trim() || "",
      utm_campaign: params.get("utm_campaign")?.trim() || "",
      utm_term: params.get("utm_term")?.trim() || "",
      utm_content: params.get("utm_content")?.trim() || ""
    };

    const existing = JSON.parse(Cookies.get("utm_data") || "{}");
    const merged = { ...existing };

    Object.entries(utmParams).forEach(([key, value]) => {
      if (value) merged[key] = value;
    });

    if (Object.keys(merged).length > 0) {
      Cookies.set("utm_data", JSON.stringify(merged), { expires: startOfTomorrow() });
    }
  }, [location.search]);
}

export default useUTMTracker;
